function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['global-breakdowns'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`multi-group-by`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-query-multi-block", {
            "attrs": Object.assign($helpers.getPropertyMenuAttributes(`breakdown`), {
              'type': `segment`,
              'button-icon': `segment`,
              'button-text': `Breakdown`,
              'button-selector-theme': `tertiary`,
              'data-group-id': $attr(`data-group-id`),
              'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
              'event-names': JSON.stringify($helpers.getEventValues(`events`)),
              'include-custom-properties': $attr(`include-custom-properties`),
              'limit': $attr(`multi-group-by-limitation`),
              'other-group-by-options': $attr(`other-group-by-options`),
              'project-id': $attr(`project-id`),
              'selected': JSON.stringify($attr(`group-by`)),
              'selector-type': `button`,
              'show-special-date-property': $attr(`show-special-date-property`),
              'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
              'support-inline-cohorts': $attr(`support-inline-cohorts`),
              'theme': `secondary`,
              'user-id': $attr(`user-id`),
              'has-reorder-controls': true,
              'workspace-id': $attr(`workspace-id`),
            }),
            "on": {
              update: $helpers.updateGroupBy,
              track: $helpers.captureTracking,
            },
          }));;
          return __jade_nodes
        }).call(this)) : ($attr(`show-group-by`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
            "attrs": Object.assign($helpers.getPropertyMenuAttributes(`breakdown`), {
              'type': `segment`,
              'data-group-id': $attr(`data-group-id`),
              'theme': `tertiary`,
              'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
              'event-names': JSON.stringify($helpers.getEventValues(`events`)),
              'include-custom-properties': $attr(`include-custom-properties`),
              'label': `Breakdown`,
              'project-id': $attr(`project-id`),
              'removable': $helpers.hasValue(`group-by`),
              'selected': JSON.stringify($attr(`group-by`)),
              'selector-icon': `segment`,
              'selector-type': `button`,
              'user-id': $attr(`user-id`),
              'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
              'support-inline-cohorts': $attr(`support-inline-cohorts`),
              'other-group-by-options': $attr(`other-group-by-options`),
              'workspace-id': $attr(`workspace-id`),
            }),
            "dataset": {
              key: `segment`
            },
            "on": {
              remove: () => $helpers.clearSelection(`group-by`),
              select: $helpers.updateGroupBy,
              track: $helpers.captureTracking,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-and-or-prefix'] = function(idx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((idx > 0) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": {
              'menu-width': '60',
              'options': JSON.stringify($helpers.BOOLEAN_OPERATORS),
              'selected-option': $attr(`filters-operator`),
              'icon': JSON.stringify({
                rightIcon: ``
              }),
              'theme': 'secondary',
            },
            "on": {
              change: $helpers.onFiltersOperatorSelected
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['global-filters'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const menuAttrs = $helpers.getPropertyMenuAttributes();;
        __jade_nodes = __jade_nodes.concat(h("mp-query-multi-block", {
          "attrs": Object.assign(menuAttrs, {
            'type': `filter`,
            'all-data-groups': menuAttrs[`all-data-groups`] && $attr(`filter-has-data-groups`),
            'button-icon': `filter`,
            'button-text': `Filter`,
            'button-selector-theme': `tertiary`,
            'data-group-id': $attr(`data-group-id`),
            'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
            'event-names': JSON.stringify($helpers.getEventValues(`events`)),
            'project-id': $attr(`project-id`),
            'project-has-people': menuAttrs[`project-has-people`] && $attr(`filter-has-users`),
            'project-has-events': menuAttrs[`project-has-events`] && $attr(`filter-has-events`),
            'selected': JSON.stringify($attr(`filters`)),
            'selector-type': `button`,
            'show-special-date-property': $attr(`show-special-date-property`),
            'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
            'support-inline-cohorts': $attr(`support-inline-cohorts`),
            'theme': `secondary`,
            'user-id': $attr(`user-id`),
            'workspace-id': $attr(`workspace-id`),
          }),
          "dataset": {
            key: `property-filters`
          },
          "on": {
            update: $helpers.updateFilters,
            track: $helpers.captureTracking,
          },
          "props": {
            suffixRenderer: $attr(`enable-filters-operator`) ? $mixins[`filter-and-or-prefix`] : null
          },
          "class": {
            'filter-item': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-query-builder': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`data-groups-enabled`) && !$attr(`hide-data-groups-selector`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-data-group-selector", {
            "attrs": {
              'project-id': $attr(`project-id`),
              'selected-data-group-id': $attr(`data-group-id`),
              'change-warning': $helpers.getDataGroupWarning(),
              'theme': `builder`,
              'workspace-id': $attr(`workspace-id`),
            },
            "on": {
              selectDataGroup: $helpers.onDataGroupSelected
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`header`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": {
                name: `header`
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined); /*  TODO: integrate this directly from query-builder attributes */
        /*  mp-query-report-header( */
        /*    attrs=$helpers.headerAttributes(), */
        /*    props={bookmarks: bookmarks} */
        /*    on={ */
        /*      bookmarkdelete: $helpers.propagateEvent, */
        /*      bookmarkselect: $helpers.propagateEvent, */
        /*      bookmarkdraweropen: $helpers.propagateEvent, */
        /*      reset: $helpers.propagateEvent, */
        /*      save: $helpers.propagateEvent, */
        /*    } */
        /*  ) */
        __jade_nodes = __jade_nodes.concat("");
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-builder-panel': true,
            'for-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`query-type-options`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-type-selection': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": {
                  theme: `lite`,
                  size: `large`,
                  selected: $attr(`selected-query-type`),
                  options: JSON.stringify($attr(`query-type-options`)),
                  spacing: 10,
                },
                "on": {
                  select: $helpers.onQueryTypeSelected
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("mp-collapsible", {
            "attrs": {
              'header-title': $attr(`header-title`)
            },
            "on": {
              track: $helpers.captureTracking
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`section-title`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot", {
                "attrs": {
                  name: `section-title`,
                  slot: `title`
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-body': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-query-events-section", {
                "attrs": $helpers.serializeAttributes(Object.assign({
                  'add-entry-label': $attr(`add-entry-label`),
                  'can-rename-step': $attr(`show-event-rename`),
                  'data-group-id': $attr(`data-group-id`),
                  'data-groups-enabled': $attr(`data-groups-enabled`),
                  'date-range': $attr(`date-range`),
                  'disable-clone-event': $attr(`disable-clone-event`),
                  'disable-delete-event': $attr(`disable-delete-event`),
                  'event-entries': JSON.stringify($helpers.getEventEntries(`events`)),
                  'exclude-autotrack-events': $attr(`exclude-autotrack-events`),
                  'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
                  'include-custom-properties': $attr(`include-custom-properties`),
                  'is-blocked-people': !$attr(`project-has-people`),
                  'max-data-history-days': $attr(`max-data-history-days`),
                  'metrics-mode': $attr(`metrics-mode`),
                  'project-has-people': $attr(`project-has-people`),
                  'project-id': $attr(`project-id`),
                  'row-draggable': $attr(`events-draggable`),
                  'row-limit': $attr(`row-limit`),
                  'row-types': $attr(`row-types`),
                  'show-filter': $attr(`show-filter`),
                  'show-group-by': $attr(`show-group-by`),
                  'show-any-event': $attr(`show-any-event`),
                  'show-sessions': $attr(`show-sessions`),
                  'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
                  'support-inline-cohorts': $attr(`support-inline-cohorts`),
                  'row-index-toggleable': $attr(`event-index-toggleable`),
                  'row-index-toggle-label': $attr(`event-index-toggle-label`),
                  'row-label-type': $attr(`events-row-label-type`),
                  'time-display-context': $attr(`time-display-context`),
                  'track-properties': $attr(`track-properties`),
                  'user-id': $attr(`user-id`),
                  'workspace-id': $attr(`workspace-id`),
                }, $helpers.getMetricsModeAttributes())),
                "key": $attr(`row-types`),
                "on": {
                  savedCustomEvent: $helpers.onSavedCustomEvent,
                  track: $helpers.captureTracking,
                  update: ev => $helpers.updateEventSection(ev, `events`),
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean))); /* - TODO: pass this as a custom section */
          __jade_nodes = __jade_nodes.concat(($attr(`show-exclusion-steps`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-collapsible", {
              "attrs": {
                'header-title': `Exclusion Steps`,
                'is-closed': $helpers.getEventEntries(`exclusion-steps`).length === 0,
              },
              "on": {
                track: $helpers.captureTracking
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-query-body': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-query-events-section", {
                  "attrs": {
                    'add-entry-label': $attr(`add-exclusion-event-label`),
                    'data-group-id': $attr(`data-group-id`),
                    'data-groups-enabled': $attr(`data-groups-enabled`),
                    'entry-type': `exclusion-event`,
                    'exclude-autotrack-events': $attr(`exclude-autotrack-events`),
                    'include-custom-properties': $attr(`include-custom-properties`),
                    'event-entries': JSON.stringify($helpers.getEventEntries(`exclusion-steps`)),
                    'is-blocked-people': !$attr(`project-has-people`),
                    'num-exclusion-steps': $helpers.getNumExclusionSteps(),
                    'project-has-people': $attr(`project-has-people`),
                    'project-id': $attr(`project-id`),
                    'workspace-id': $attr(`workspace-id`),
                  },
                  "on": {
                    savedCustomEvent: $helpers.onSavedCustomEvent,
                    track: $helpers.captureTracking,
                    update: ev => $helpers.updateEventSection(ev, `exclusion-steps`),
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined); /*  allow dynamic sections into the query body */
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-body-sections': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": {
                name: `body-section`
              },
              "on": {
                'track': $helpers.captureTracking
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-builder-panel': true,
            'for-global': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'left-controls': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!$attr(`hide-date-picker`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
                "attrs": {
                  'type': `time`,
                  'display-context': $attr(`time-display-context`),
                  'label': `Select date`,
                  'max-data-history-days': $attr(`max-data-history-days`),
                  'selected': JSON.stringify($attr(`date-range`)),
                  'selector-type': `button`,
                  'selector-icon': `calendar`,
                  'workspace-id': `number`,
                },
                "dataset": {
                  key: `time`
                },
                "on": {
                  select: $helpers.updateTime,
                  track: $helpers.captureTracking,
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(($attr(`show-filter`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['global-filters'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(jade_mixins['global-breakdowns'].call(this));
            __jade_nodes = __jade_nodes.concat(($helpers.showAttributionSelector()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'breakdown-attribution-options': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("on");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'sections': JSON.stringify([{
                      items: $attr(`breakdown-attribution`)
                    }]),
                    'selected-option': $helpers.getAttributionSelectedOption(),
                    'theme': `builder`,
                    'menu-width': 200,
                    'tab-index': 0,
                  },
                  "on": {
                    change: $helpers.updateAttributionSelection
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(($helpers.showFunnelAttributionSelector()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'breakdown-attribution-options': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("using");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    'max-width': `300px`
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Attribution applied to filters and breakdowns");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'sections': JSON.stringify($helpers.funnelAttributionItems()),
                    'theme': `builder`,
                    'menu-width': 200,
                    'tab-index': 0,
                  },
                  "on": {
                    change: $helpers.updateFunnelAttributionSelection
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`chart-controls`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'right-controls': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot", {
                "attrs": {
                  name: `chart-controls`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;